import { useState } from 'react';
import { toast } from 'sonner';
import { api, formatApiErrorDetail } from '@/lib/api';
import { Reveal } from '@/components/Reveal';
import { useContent } from '@/lib/useContent';

const FIELD = 'w-full border border-brayo-line bg-white px-4 py-3.5 text-base md:text-sm text-brayo-charcoal placeholder:text-brayo-dim focus:border-brayo-blue focus:outline-none transition-colors';

export default function Newsletters() {
  const content = useContent();
  const [form, setForm] = useState({ email: '', firstName: '' });
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/submissions', {
        name: form.firstName || 'Subscriber',
        email: form.email,
        department: 'Newsletter',
      });
      toast.success('You are on the list.');
      setForm({ email: '', firstName: '' });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    }
  };

  return (
    <div data-testid="newsletters-page" className="mx-auto max-w-[1200px] px-5 pb-28 pt-36 md:px-10 md:pt-48">
      <div className="grid items-center gap-14 lg:grid-cols-2 lg:gap-20">
        <Reveal>
          <p className="meta-label text-brayo-blue">Newsletter</p>
          <h1 className="display-title mt-4 text-5xl text-brayo-charcoal sm:text-6xl lg:text-7xl">
            Join the
            <br />
            <span className="text-brayo-blue">{content.mailing_title || 'Mailing List'}</span>
          </h1>
        </Reveal>

        <Reveal delay={0.12}>
          <form data-testid="mailing-list-form" onSubmit={submit} className="border border-brayo-line bg-white p-8 shadow-[0_24px_60px_-40px_rgba(22,22,22,0.3)] md:p-10">
            <p className="meta-label mb-8 text-brayo-blue">Sign Up</p>
            <div className="space-y-5">
              <label className="block">
                <span className="meta-label mb-2 block text-brayo-dim">Email Address <span className="text-brayo-blue">*</span></span>
                <input data-testid="mailing-list-email-input" type="email" required value={form.email} onChange={set('email')} className={FIELD} />
              </label>
              <label className="block">
                <span className="meta-label mb-2 block text-brayo-dim">First Name</span>
                <input data-testid="mailing-list-firstname-input" value={form.firstName} onChange={set('firstName')} className={FIELD} />
              </label>
              <button data-testid="mailing-list-subscribe-btn" type="submit" className="meta-label w-full bg-brayo-blue py-4 text-white transition-colors hover:bg-brayo-charcoal">
                Subscribe
              </button>
              <p className="meta-label text-center text-brayo-dim"><span className="text-brayo-blue">*</span> Required</p>
            </div>
          </form>
        </Reveal>
      </div>
    </div>
  );
}